var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex-wrapper",style:(_vm.$vuetify.breakpoint.xsOnly ? _vm.mobileStyles : '')},[_c('div',{staticClass:"flex-content"},[_vm._t("content")],2),_c('div',{staticClass:"footer-wrapper"},[_vm._t("footer")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }